import Parse from "parse";

export interface RegionAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;
  name: string;
}

export class Region extends Parse.Object<RegionAttributes> {
  static className: string = "Antiscam_Region";

  constructor(data?: Partial<RegionAttributes>) {
    super("Antiscam_Region", data as RegionAttributes);
  }

  get name(): string {
    return super.get("name");
  }
  set name(value: string) {
    super.set("name", value);
  }
}

Parse.Object.registerSubclass("Antiscam_Region", Region);
